import { listingsApiV1 } from '@app/services'

import { FetchProjectsTotalResponse } from './types'

export const fetchProjectsTotal = async (): Promise<number> => {
  try {
    const { data } = await listingsApiV1.get<FetchProjectsTotalResponse>(
      'projects',
      {
        params: {
          'query.mode': 'OnlyTotal',
        },
      }
    )

    return data.total
  } catch (error) {
    console.error('Failed to fetch projects total', error)
    return 0
  }
}
